import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";
import { Icon } from "@/lib/Icon";
import { Reveal, stagger, item } from "@/lib/motionPrimitives";

export default function Services() {
  return (
    <section id="services" className="relative bg-surface py-24 md:py-32" data-testid="services">
      <div className="container-x">
        <Reveal className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="overline">What We Offer</p>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
              Our Services
            </h2>
          </div>
          <p className="max-w-md text-muted-foreground">
            End-to-end industrial painting and coating — from surface preparation to long-lasting protective finishes.
          </p>
        </Reveal>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
        >
          {SERVICES.map((s) => (
            <motion.article
              key={s.title}
              variants={item}
              data-testid={`service-card-${s.title}`}
              className="group relative flex flex-col rounded-3xl border border-border bg-background p-7 transition-colors duration-300 hover:border-primary"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary transition-colors duration-300 group-hover:bg-primary group-hover:text-primary-foreground">
                <Icon name={s.icon} className="h-6 w-6" />
              </div>
              <h3 className="mt-5 font-display text-lg font-semibold">{s.title}</h3>
              <p className="mt-2 flex-1 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
              <a
                href="#contact"
                className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-primary"
                data-testid={`service-learn-more-${s.title}`}
              >
                Learn More
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
